<template
  ><v-card class="p-4">
    <v-card-title>
      Nos clients
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Rechercher sur les noms"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>

      <export-btn entity="clients"/>

      <!-- bouton trash à partir de 2 checkbox de cocher -->
      <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="red" data-toggle="tooltip" title="Suppression des clients sélectionnées" >
        <v-icon dark v-model="selected" small @click="deleteClients(selected[0].client)">
          mdi-delete
        </v-icon>
      </v-btn>

      <!-- <v-btn v-if="selected.length >= 2" class="mx-2" fab dark small color="purple darken-2">
        <v-icon dark v-model="selected" small @click.stop="dialog = true">
          mdi-pencil
        </v-icon>
      </v-btn> -->

      <router-link :to="{ name: 'creerClient' }">
        <v-btn class="mx-2" fab dark small color="indigo" data-toggle="tooltip" title="Création d'un client">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </router-link>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="clients"
      :search="search"
      :items-per-page="12"
      :page.sync="pagination.currentPage"
      @page-count="pageCountChange"
      hide-default-footer
      v-model="selected"
      :single-select="singleSelect"
      show-select
    >
      <template v-slot:[`item.actions`]="{ item }">
        <router-link :to="{ name: 'modifierClient', params: { id: item.id, client: item }}">
          <v-icon small class="mr-2">
            mdi-pencil
          </v-icon>
          </router-link>

          <v-icon small @click="deleteClient(item)">
            mdi-delete
          </v-icon>
      </template>
    </v-data-table>

    <v-pagination
      v-model="pagination.currentPage"
      :length="pagination.pagesNumber"
      class="pt-5"
    ></v-pagination>
  </v-card>
</template>

<style scoped>
::v-deep .v-data-table__empty-wrapper {
  display: none;
}
</style>
<script>

//import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";
import ExportBtn from "@/components/admin/exportBtn";

export default {
  name: "clients",
  components: { ExportBtn },
  data() {
    return {
      confirmDelete: false,
      loading: true,
      options: {},
      search: "",
      headers: [
        { text: "Société", value: "name", align: "start" },
        { text: "E-mail", value: "email", align: "start" },
        { text: "Nombre d'utilisateurs", value: "users.length", align: "start" },
        //{ text: "Droits utilisateurs associés", value: "TODO: boucle pour fetch all userRight ?", align: "start" },
        { text: "Droits utilisateurs associés", value: "userRights.length", align: "start" },
        { text: "Commentaire", value: "comment", align: "start" },
        { text: "Actions", value: "actions", sortable: false, align: "start" },
      ],
      pagination: {
        currentPage: 1,
        pagesNumber: 0,
      },
      deletedIndex: -1,
      singleSelect: false,
      selected: [], // Liste des clients sélectionnés dans le tableau
      clients: [],
      userRights: [],
    };
  },

  watch: {
    search(value) {
      this.search = value;
      this.pagination.currentPage = 1;
      this.getAllUsers();
    },
    options: {
      handler() {
        this.getAllUsers();
      },
      deep: true
    }
  },

  methods: {
    getAllClients() {
      this.loading = true;
      Api.get("clients?pagination=false").then((clients) => {
        this.clients = clients.data["hydra:member"];
        this.loading = false;
      });
    },
    deleteClient(item) {
      if(item.users.length === 0){
        Swal.fire({
          title: "Voulez-vous vraiment supprimer ce client ?",
          text: "Attention, cette action est irréversible !",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui, supprimer",
          cancelButtonText: "Annuler",
        }).then((result) => {
          if (result.isConfirmed) {
            this.deletedIndex = this.clients.indexOf(item);
            Api.delete("clients/" + item.id).then(() => {
              this.clients.splice(this.deletedIndex, 1),
                Swal.fire(
                  "Supprimé !",
                  "Votre client a été supprimée",
                  "success"
                ),
                this.getAllClients();
            });
          }
        })
      }else{
        Swal.fire(
          "Attention",
          "Votre client est encore associé à d'autres utilisateurs, il ne peut donc être supprimé",
          "error"
        )}
    },

    deleteClients() {
      const selectedItems = this.selected
      let deletable = true // select client qui n'ont pas d'utilisateur
      for(var i=0; i < selectedItems.length; i++){
        if(selectedItems[i].users.length > 0) {
          deletable = false
        }
      }
      if(deletable){
        Swal.fire({
            title: "Voulez-vous vraiment supprimer ce client ?",
            text: "Attention, cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Annuler",
          })
          .then((result) => {
            if (result.isConfirmed) {
              const selectedItems = this.selected
              for(var i=0; i < selectedItems.length; i++){
                Api.delete("clients/" + selectedItems[i].id).then(() => {
                  Swal.fire(
                    "Supprimé !",
                    "Votre client a été supprimé",
                    "success"
                  )
                  //this.selected = [];
                  this.getAllClients();
                });
              }
            }
          })
        }else{
        Swal.fire(
        "Attention",
        "Votre client est encore associé à d'autres utilisateurs, il ne peut donc être supprimé. Merci de vérifier votre sélection et déselectionner le droit utilisateur ayant un nombre d'utilisateur différent de 0.",
        "error"
        )
      }
    },

    pageCountChange(pageCount) {
      this.pagination.pagesNumber = pageCount;
    },
  },
  mounted() {
    // this.$store.dispatch(SET_BREADCRUMB, [
    //   { title: "Administration", route: "gestionClients"},
    //   { title: "Gestion des clients" },
    // ]);
    this.getAllClients();
  }
}
</script>
